import axios from "../configs/axios";

export interface ApiResponse<T> {
  code: number;
  message: string;
  data: T;
}

export type WhatsNewType =
  | "release"
  | "product-sheet"
  | "document"
  | "brand-guide"
  | "graphics"
  | "webinar"
  | "academy";

export interface WhatsNewItem {
  type: WhatsNewType;
  id: string;
  title: string;
  description: string;
  createdAt: string;
  updatedAt: string;
  route: string;
  fileType?: string;
  fileKey?: string;
  isVideo?: boolean;
  isNew: boolean;
}

export interface WhatsNewResponse {
  items: WhatsNewItem[];
  newCount: number;
  since: string | null;
}

const LAST_SEEN_KEY = "lastDashboardSeenAt";

/** When the user last viewed the dashboard (ISO string), or null on first visit. */
export const getLastSeen = (): string | null => {
  try {
    return localStorage.getItem(LAST_SEEN_KEY);
  } catch {
    return null;
  }
};

/** Mark the dashboard as seen now, so future loads only flag items after this. */
export const markDashboardSeen = (): void => {
  try {
    localStorage.setItem(LAST_SEEN_KEY, new Date().toISOString());
  } catch {
    /* ignore (private mode / disabled storage) */
  }
};

export const whatsNewApi = {
  // Authenticated; the shared axios instance attaches the Bearer token.
  // When `since` is omitted the backend falls back to the user's stored
  // server-side baseline (so "new" follows them across devices).
  getWhatsNew: async (
    since?: string | null,
    limit = 30
  ): Promise<ApiResponse<WhatsNewResponse>> => {
    const response = await axios.get("/whats-new", {
      params: { ...(since ? { since } : {}), limit },
    });
    return response.data;
  },

  // Record on the server that the user has now seen the feed.
  markSeen: async (): Promise<ApiResponse<{ seenAt: string }>> => {
    const response = await axios.post("/whats-new/seen");
    return response.data;
  },
};
